const html = (i) => `
<html>
    <head>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.3.0/paper.css">
        <style>@media print{@page{size: A5 landscape}}</style>
    </head>
    <body class="A5 landscape" style="font-family:monospace;">
        <section class="sheet padding-10mm">
            <article>${i.FirmaUnvan || '*'}  ${i.WebSite || '*'}</article>
            <article>Tic.Sic/Merkez:/</article>
            <br>
            <article>${i.Tarih || '*'}</article>
            <table style="border-collapse:collapse;">
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>${i.Title || '*'}</td>
                    </tr>
                    <tr>
                        <td>İSİM</td>
                        <td>&nbsp;:</td>
                        <td>${i.CariAdi || '*'}</td>
                    </tr>
                    <tr>
                        <td>KODU</td>
                        <td>&nbsp;:</td>
                        <td>${i.CariKodu || '*'}</td>
                    </tr>
                    <tr>
                        <td>ADRES</td>
                        <td>&nbsp;:</td>
                        <td>${i.CariAdres || '*'}</td>
                    </tr>
                    <tr>
                        <td>İL/İLÇE</td>
                        <td>&nbsp;:</td>
                        <td>${i.CariIl || '*'}/${i.CariIlce || '*'}</td>
                    </tr>
                    <tr>
                        <td>VER. DAİRE/NUMARA</td>
                        <td>&nbsp;:</td>
                        <td>${i.VergiDairesi || '*'}/${i.VergiNumarasi || '*'}</td>
                    </tr>
                    <tr>
                        <td>FİŞ NO</td>
                        <td>&nbsp;:</td>
                        <td>${i.FisNo || '*'}</td>
                    </tr>
                    <tr><td colspan="3"><br/></td></tr>
                    <tr style="border-bottom: 1px dashed #ccc;">
                        <td></td>
                        <td></td>
                        <td style="padding-bottom:4px;"> AÇIKLAMA</td>
                    </tr>
                    <tr style="border-bottom: 1px dashed #ccc;">
                        <td colspan=3 style="padding-bottom:10px;padding-top:10px;">
                            ${i.Aciklama || 'YOK'}
                        </td>
                    </tr>
                    <tr><td colspan="3"><br/></td></tr>
                    <tr>
                        <td>TOPLAM</td>
                        <td>&nbsp;:</td>
                        <td>${i.ToplamTutar || '*'}</td>
                    </tr>
                    <tr>
                        <td colspan=3>
                            ${i.ToplamTutarAciklama || '*'}
                        </td>
                    </tr>
                </tbody>
            </table>
            <br/><br/>
            <table style="width:100%">
                <tbody>
                    <tr>
                        <td style="width:50%">TESLİM EDEN</td>
                        <td style="width:50%">TESLİM ALAN</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>${i.TeslimAlan || '*'}</td>
                    </tr>
                </tbody>
            </table>
        </section>
    </body>
</html>
`

const settings = `toolbar=no,
location=no,
status=no,
menubar=no,
scrollbars=yes,
resizable=yes,
width=830,
height=590`

export const printFis = (i) => {
    var wnd = window.open("about:blank", "", settings);
    wnd.document.write(html(i));
    wnd.print()
}